/*****************************************************************************************************************************************************
 * Contract monitoring *
 ****************************************************************************************************************************************************/
define('commons/monitoring/contract-monitoring',['jquery', 'commons/monitoring/base-monitoring'], function($, BaseMonitoring) {

    var ContractMonitoring = function() {
        // Call parent init method
        BaseMonitoring.apply(this, arguments);
    };

    // Inherit from MessageMonitoring
    for ( var element in BaseMonitoring.prototype) {
        ContractMonitoring.prototype[element] = BaseMonitoring.prototype[element];
    }

    ContractMonitoring.prototype.processResponse = function(result) {
        var data = [];
        var labels = ["Time"];

        if (result && result.cumulated) {
            labels.push("Cumulated");
            for (var i = 0; i < result.cumulated.length; i++) {
                var date = new Date();
                date.setTime(result.startTime + i * (24 * 60 * 60 * 1000)); // Add one day for each data
                data.push([date, result.cumulated[i]]);
            }
        }

        if (this.mapping.labels && this.mapping.keys && result && result.dailyContractConsumption) {
            for (var i = 0; i < this.mapping.labels.length; i++) {
                labels.push(this.mapping.labels[i]);
            }

            var keysLength = this.mapping.keys.length;

            for (var i = 0; i < result.dailyContractConsumption.consumptions.length; i++) {
                if (!result.cumulated && keysLength > 0) {
                    var date = new Date();
                    date.setTime(result.startTime + i * (24 * 60 * 60 * 1000));
                    data.push([date]);
                }
                for (var j = 0; j < keysLength; j++) {
                    var key = this.mapping.keys[j];
                    if (result.cumulated || keysLength > 0) {
                        data[i].push(result.dailyContractConsumption.consumptions[i][key]);
                    } else {
                        var date = new Date();
                        date.setTime(result.startTime + i * (24 * 60 * 60 * 1000)); // Add one day for each data
                        var d = [date, result.dailyContractConsumption.consumptions[i][key]];
                        data.push(d);
                    }
                }
            }
        }

        return {
            data: data,
            labels: labels,
            drawOptions: {
                stepPlot: true
            }
        };
    };

    return ContractMonitoring;
});
